<div class="radio-box-group wrap-below-{{wrapBelow()}}">
    <ng-content />
    @for (item of itemsComputed(); track item.value) {
        <radio-box-button
            [type]="item.type"
            [value]="item.value"
            [name]="item.name"
            [description]="item.description"
            [label]="item.label"
            [labelTextColor]="item.labelTextColor"
            [labelBackgroundColor]="item.labelBackgroundColor"
            [inputLabel]="item.inputLabel || ''"
            [unit]="item.unit"
            [format]="item.format || '1.0-0'"
            [wrapBelow]="wrapBelow()"
            class="wrap-below-{{wrapBelow()}}"
        />
    }
</div>

